<template>
  <modal
    width="600px"
    :title="t('Shared Report Link')"
    @close="close"
    :read-article-url="`https://docs.bemob.com/${locale}/shared-report`"
  >
    <template #default>
      <div>
        <ui-info class="mb-16">
            <div v-if="isTreeView">{{ t('All the reports will be shared in tableview.') }}</div>
            <div>{{ t("Click on Copy to grab the link and share it with the 3-rd parties without providing the access to your account. The permanent link for this report is available in Settings -> Multi-User Access -> Shared Reports.") }}</div>
          </ui-info>
          <div class="name">{{ data.name }}</div>
          <ui-copy-input
            class="copy"
            :model-value="link"
            :label="t('Shared Link')"
          ></ui-copy-input>
      </div>
    </template>

    <template #footer>
      <section class="justify-end xs12" style="display: flex; width: 100%">
        <div class="d-flex justify-end">
          <ui-button
            icon="fas fa-times"
            :text="t('Close')"
            @click="close"
          ></ui-button>
        </div>
      </section>
    </template>
  </modal>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n, useReportParams, useTableQuery } from '@/composables';
import config from '@/config';

const props = withDefaults(
  defineProps<{
    data?: { id?: string; name?: string };
  }>(),
  {
    data: () => ({}),
  },
);

const emit = defineEmits<{
  close: [];
}>();

const { t, locale } = useI18n();
const reportParamsApi = useReportParams();
const tableQueryApi = useTableQuery();

const link = computed(() => `${config.sharedReportsURL}/${props.data.id || ''}`);

const isTreeView = computed(() => {
  const reportParams = reportParamsApi.getReportParams();
  const tableQuery = tableQueryApi.getTableQueryForCurrentTab();
  const treeLevels = tableQuery.treeLevels as string[] | undefined;
  return reportParams.view === 'tree' && treeLevels?.some((item) => item);
});

const close = () => {
  emit('close');
};
</script>


<style lang="scss" scoped>
.copy {
  margin-top: 25px;
  :deep(input),
  :deep(.v-input__append-inner) {
    border-bottom: none!important;
  }
}

.table-hidden-input {
  position: absolute;
  opacity: 0;
  z-index: -1000;
}

.link-container {
  display: flex;
  justify-content: space-between;
}

.name {
  word-break: break-all;
  font-size: 16px;
  font-weight: bold;
}

.link {
  margin-top: 15px;
  font-size: 13px;
  font-weight: bold;
  color: var(--color-graphite);
}

</style>
